import {
	OPEN_GLOBAL_ISSUE_CREATE,
	CLOSE_GLOBAL_ISSUE_CREATE,
} from '../../../actions/global-issue-create/index.tsx';
import type { Action } from '../../../types.tsx';
import type { GlobalIssueCreateState } from './types.tsx';

const defaultState = { isOpen: false } as const;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: GlobalIssueCreateState = defaultState,
	action: Action,
): GlobalIssueCreateState => {
	if (action.type === OPEN_GLOBAL_ISSUE_CREATE) {
		return {
			isOpen: true,
			inputs: action.payload,
		};
	}
	if (action.type === CLOSE_GLOBAL_ISSUE_CREATE) {
		return { isOpen: false };
	}

	return state;
};
